<template>
  <page-header-wrapper>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="vertical">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.orders"
              placeholder="请输入要搜索的订单号"
              enter-button
              allow-clear
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <a-row :gutter="48">
            <a-col :md="24" :sm="24">
              <a-form-item label="用户">
                <a-select
                  mode="multiple"
                  optionFilterProp="children"
                  showArrow
                  allow-clear
                  placeholder="请输入要搜索的用户"
                  v-model="params.where.member_id"
                  @search="getUserList"
                  @change="getLists()"
                >
                  <a-select-option v-for="item in userList" :key="item.id.toString()">
                    <template v-if="item.phone"> {{ item.phone }}-</template
                    ><template v-if="item.real_name"> {{ item.real_name }}-</template>
                    <template v-if="item.email"> {{ item.email }}</template>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="快递单号">
                <a-input
                  v-model="params.where.express_order_id"
                  allow-clear
                  placeholder="请输入快递单号"
                  @pressEnter="getLists()"
                />
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="身份证号">
                <a-input
                  v-model="params.where.idcard"
                  allow-clear
                  placeholder="请输入要搜索的身份证号"
                  @pressEnter="getLists()"
                />
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="企业电话">
                <a-input v-model="params.where.tel" @pressEnter="getLists()" allow-clear placeholder="请输入要搜索的企业电话" />
              </a-form-item>
            </a-col>

            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="接收邮箱">
                <a-input v-model="params.where.email" @pressEnter="getLists()" allow-clear placeholder="请输入要接收邮箱" />
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="是否开票">
                <a-select
                  allow-clear
                  v-model="params.where.state"
                  @change="getLists()"
                >
                  <a-select-option value="1">未开票</a-select-option>
                  <a-select-option value="2">开票中</a-select-option>
                  <a-select-option value="3">已开票</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="发票类型">
                <a-select
                  allow-clear
                  v-model="params.where.is_spe"
                  @change="getLists()"
                >
                  <a-select-option value="1">专票</a-select-option>
                  <a-select-option value="2">普票</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="日期范围">
                <a-range-picker
                  :ranges="{
                    最近七天: [moment().subtract('days', 6), moment()],
                    今天: [moment(), moment()],
                    本月: [moment().startOf('month'), moment()]
                  }"
                  :placeholder="['开始日期', '结束日期']"
                  @change="value => handleChangeDate(value)"
                />
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="开票类型">
                <a-radio-group v-model="params.where.type" @change="getLists()">
                  <a-radio-button value>全部</a-radio-button>
                  <a-radio-button value="2">个人</a-radio-button>
                  <a-radio-button value="1">公司</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </a-form>
    </a-card>

    <a-card style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="d-flex change-state">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
        <export
          :columns="columns"
          :params="params"
          :url="apiList.getList"
          xlsxName="发票列表"
          v-action:export
          @click="getExportData"
        />
        <a-button
          v-action:state
          :disabled="selectedRowKeys.length === 0"
          @click="handleApplyFor"
        >批量发票管理</a-button
        >
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <template slot="ordersn" slot-scope="order">
          <div class="order-item" v-for="(item, key) in order" :key="key">{{ item.sn }}({{ payTypeFilter(item.pay_type).value }})</div>
        </template>
        <template slot="addressTel" slot-scope="value, record">{{ value }} {{ record.tel }}</template>
        <template slot="bankAccount" slot-scope="value, record">{{ value }} {{ record.account }}</template>
        <template slot="sendInfo" slot-scope="value, record">
          <span
            v-if="record.is_spe === 1"
          >{{ value }}，{{ record.send_phone }}，{{ record.send_address }}</span
          >
          <span v-else></span>
        </template>
        <template slot="money" slot-scope="text">{{ (text / 100) | NumberFormat }}</template>
        <template slot="is_spe" slot-scope="text">{{ text === 1 ? '专用发票' : '普通发票' }}</template>
        <template slot="type" slot-scope="text">{{ text === 1 ? '个人' : '企业' }}</template>
        <template slot="state" slot-scope="text">{{ getState(text) }}</template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, select } from '@/mixins' // 引入
import { StandardFormRow, TableToolBarList, Export } from '@/components'
import { ModelForm, ModelApply } from './modules'
import { requestGet } from '@/api/api'

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '用户名称',
        dataIndex: 'member.real_name'
    },
    {
        title: '订单信息',
        dataIndex: 'order_lists',
        width: 300,
        scopedSlots: { customRender: 'ordersn' }
    },
    {
        title: '名称',
        dataIndex: 'name'
    },
    {
        title: '开票金额',
        dataIndex: 'money',
        scopedSlots: { customRender: 'money' }
    },
    {
        title: '开票类型',
        dataIndex: 'type',
        scopedSlots: { customRender: 'type' }
    },
    {
        title: '是否专票',
        dataIndex: 'is_spe',
        align: 'center',
        scopedSlots: { customRender: 'is_spe' }
    },
    {
        title: '费用类型',
        dataIndex: 'entry',
        align: 'center'
    },
    {
        title: '身份证号',
        dataIndex: 'idcard',
        sorter: true
    },
    {
        title: '税号',
        dataIndex: 'code',
        sorter: true
    },
    {
        title: '地址电话',
        dataIndex: 'address',
        sorter: true,
        scopedSlots: { customRender: 'addressTel' },
        width: 300
    },
    {
        title: '银行账户',
        dataIndex: 'bank',
        sorter: true,
        scopedSlots: { customRender: 'bankAccount' },
        width: 300
    },
    {
        title: '收件人',
        dataIndex: 'send_name',
        sorter: true,
        scopedSlots: { customRender: 'sendInfo' },
        width: 300
    },
    {
        title: '收件邮箱',
        dataIndex: 'email'
    },
    {
        title: '快递单号',
        dataIndex: 'express_order_id',
        sorter: true
    },
    {
        title: '创建时间',
        align: 'center',
        dataIndex: 'created_at'
    },
    {
        title: '开票状态',
        dataIndex: 'state',
        align: 'center',
        fixed: 'right',
        width: 120,
        scopedSlots: { customRender: 'state' }
    }
]

const apiList = {
    getList: '/finances/invoices',
    changeState: '/finances/invoices/',
    userList: '/members/select'
}

export default {
    name: 'FinanceList',
    mixins: [ list, table, select ], // 使用mixins
    components: {
        StandardFormRow,
        ModelForm,
        ModelApply,
        TableToolBarList,
        Export
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)), // 深度复制表头
            selectedRowKeys: [], // table批量选择
            scroll: {
                x: 2800
            },
            typeList: [], // 开票类型
            userList: null
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
        this.getUserList() // 获取用户位列表
    },
    computed: {
        payTypeFilter (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '微信', color: 'green' },
                    2: { value: '支付宝', color: 'blue' },
                    3: { value: '银联', color: 'gold' },
                    4: { value: '免费', color: 'red' }
                }
                return statusMap[status]
            }
        },
        getState (state) {
            return function (state) {
                const statusMap = {
                    1: '待开票',
                    2: '开票中',
                    3: '已开票'
                }
                return statusMap[state]
            }
        }
    },
    methods: {
        /**
         * 获取用户下拉列表
         * @param
         * @jdy
         */
        getUserList (value) {
            requestGet(apiList.userList, { member: value })
                .then(res => {
                    this.memberLoad = false
                    this.userList = res.result
                })
                .catch(err => {
                    this.$notification.error(err)
                })
        },
        /**
         * 获取打印数据
         * @jdy
         *newColumns,data
         * @2020-11-30
         */
        getExportData (columns, data) {
            data.filter(item => {
                const orderLists = item.order_lists.map(item => {
                    return item.sn + '(' + this.payTypeFilter(item.pay_type).value + ')'
                })
                item.order_lists = orderLists.join(';')
                item.money = item.money / 100
                const address = item.address ? item.address : ''
                const tel = item.tel ? item.tel : ''
                const bank = item.bank ? item.bank : ''
                const account = item.account ? item.account : ''
                item.address = address + ' ' + tel
                item.bank = bank + ' ' + account
                item.send_name = item.is_spe === 1 ? item.send_name + '，' + item.send_phone + '，' + item.send_address : ''
                item.is_spe = item.is_spe === 1 ? '专用发票' : '普通发票'
                item.type = item.type === 1 ? '个人' : '企业'
                item.state = this.getState(item.state)
            })
            this.outputXlsxFile(columns, data, '**发票列表' + this.moment(new Date()).format('YYYYMMDDHHmmss'))
        },
        /**
         * 列表选择
         * 获取选择的id数组及选择行数据
         * @jdy
         */
        onSelectChange (selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        /**
         * 筛选类型
         * @params
         * @jyd
         * @10-22
         */
        handleSearchType (e) {
            this.getLists()
        },
        /**
         * 批量申请发票
         * @param
         * @jdy
         * @2020-11-26
         */
        handleApplyFor () {
            const that = this
            const { selectedRowKeys } = that
            that.$dialog(
                ModelApply,
                {
                    aid: selectedRowKeys,
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                // modal props
                {
                    title: '批量修改状态',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        },
        /**
         * 弹窗输入快递单号
         * aid广告id
         * @params
         *
         * ModelForm
         */
        handleExpressSave (aid) {
            this.$dialog(
                ModelForm,
                {
                    aid,
                    on: {
                        ok () {},
                        cancel () {},
                        close () {}
                    }
                },
                // modal props
                {
                    title: '填写快递单号',
                    centered: true,
                    maskClosable: false
                }
            )
        }
    }
}
</script>

<style lang="less">
.order-item {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
}
</style>
